export default __webpack_public_path__ + "static/media/ic_error.f94e838a.svg";